// Generated by purs version 0.15.15
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_Geocoding_RPC_Sites_Types from "../Restaumatic.Geocoding.RPC.Sites.Types/index.js";
import * as Restaumatic_Geocoding_Types_ReverseGeocodeRequest from "../Restaumatic.Geocoding.Types.ReverseGeocodeRequest/index.js";
import * as Restaumatic_Site_RPC from "../Restaumatic.Site.RPC/index.js";
var sitesRPC = /* #__PURE__ */ Restaumatic_Site_RPC.sitesRPC(/* #__PURE__ */ Network_JsonRPC.encodeRequest(Restaumatic_Geocoding_Types_ReverseGeocodeRequest.encodeReverseGeocodeRequest)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Geocoding_Types_ReverseGeocodeRequest.encodeReverseGeocodeRequest)))(/* #__PURE__ */ Network_JsonRPC.decodeResponse(Restaumatic_Geocoding_RPC_Sites_Types.decodeReverseGeocodeResponse))(Restaumatic_Geocoding_Types_ReverseGeocodeRequest.rPCMethodNameReverseGeoco);
var reverseGeocode = function (restaurantId) {
    return function (coordinates) {
        return sitesRPC({
            coordinates: coordinates,
            restaurantId: restaurantId
        });
    };
};
export {
    reverseGeocode
};
